import { useEffect, useState } from "react";
import { fetchRolesByPermission } from "../../api/accessControl";

export default function PermissionDetailsDrawer({ permission, onClose }) {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (permission) {
      fetchRolesByPermission(permission.id).then(setRoles);
    }
  }, [permission]);

  if (!permission) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black/30 dark:bg-black/60">
      <div className="h-full w-[420px] bg-white p-6 text-gray-900 shadow-xl dark:bg-gray-900 dark:text-gray-100">
        <button
          onClick={onClose}
          className="mb-4 text-sm text-gray-700 transition hover:text-gray-900 dark:text-gray-300 dark:hover:text-white"
        >
          ← Close
        </button>

        <h2 className="mb-2 text-xl font-bold text-gray-900 dark:text-white">
          {permission.code}
        </h2>

        <p className="mb-4 text-gray-600 dark:text-gray-400">
          {permission.description}
        </p>

        <h3 className="mb-3 font-semibold text-gray-900 dark:text-white">
          Roles
        </h3>

        {roles.length === 0 ? (
          <p className="text-gray-500 dark:text-gray-400">No roles</p>
        ) : (
          <ul className="space-y-2">
            {roles.map((r) => (
              <li
                key={r.id}
                className="rounded bg-gray-100 px-3 py-2 text-gray-800 dark:bg-gray-800 dark:text-gray-200"
              >
                {r.name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}